/**
 * @fileoverview Provides helpers for the Knowledge Tags JS methods
 *
 * @author Eugene Gurevich (egurevich@yext.com)
 *
 * We don't use the yext namespace because it clashes with the externs for
 * the analytics library, which is loaded dynamically.
 */
goog.provide('yextschema.helpers');

/**
 * @param {!Element} element
 */
yextschema.helpers.getEntityId = function(element) {
  var entityId = element.getAttribute('data-yext-id');
  if (!entityId) {
    // data-yext-location-id is deprecated; kept for backward compatibility
    entityId = element.getAttribute('data-yext-location-id');
  }
  return entityId;
};

/**
 * @param {!Element} element
 * @param {string}  entityId
 * @param {boolean} requireEntityId
 */
yextschema.helpers.skipElement = function(element, entityId, requireEntityId) {
  return requireEntityId && entityId !== yextschema.helpers.getEntityId(element);
};

/**
 * @param {!HTMLImageElement} element
 * @param {string}  url
 */
yextschema.helpers.injectImg = function(element, url) {
  if (typeof url === 'string') {
    // this replaces both http:// and https://
    url = url.replace(/https?:\/\//, '//');
  }
  element.src = url;
};
